import { ScrollingModule } from "@angular/cdk/scrolling";
import { HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule, Routes } from "@angular/router";
import { FuseSidebarModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "app/helper-components/Shared.module";
import { LazyForDirective } from "../../directives/lazyFor.directive";
import { AddboothFormComponent } from "./addbooth-form/addbooth-form.component";
import { ConformGenderComponent } from "./conform-gender/conform-gender.component";
import { ConstituencyBoothComponent } from "./constituency-booth.component";
import { EditVotsComponent } from "./edit-vots/edit-vots.component";
const routes: Routes = [
  {
    path: "const_booth",
    component: ConstituencyBoothComponent,
    // data: { shouldReuse: true },
  },
];
@NgModule({
  declarations: [
    ConstituencyBoothComponent,
    EditVotsComponent,
    AddboothFormComponent,
    ConformGenderComponent,
    LazyForDirective,
  ],
  providers: [
    // BoothDataService,
    //   {
    //     provide: RouteReuseStrategy,
    //     useClass: RouteReuseStrategyService,
    //   },
  ],
  // bootstrap: [ConstituencyBoothComponent],
  imports: [
    RouterModule.forChild(routes),
    // RouterModule.forRoot(routes),
    BrowserModule,
    HttpClientModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,

    FuseSharedModule,
    FuseSidebarModule,

    TranslateModule,
    SharedModule,

    MatCardModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatDialogModule,
    MatTooltipModule,
    MatExpansionModule,
    FormsModule,
    MatSlideToggleModule,
    ScrollingModule,
  ],
  exports: [EditVotsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConstituencyBoothModule {}
